/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateIcrTouchConnectionData
 */
export interface UpdateIcrTouchConnectionData {
    /**
     * 
     * @type {string}
     * @memberof UpdateIcrTouchConnectionData
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateIcrTouchConnectionData
     */
    tak?: string;
}

/**
 * Check if a given object implements the UpdateIcrTouchConnectionData interface.
 */
export function instanceOfUpdateIcrTouchConnectionData(value: object): value is UpdateIcrTouchConnectionData {
    return true;
}

export function UpdateIcrTouchConnectionDataFromJSON(json: any): UpdateIcrTouchConnectionData {
    return UpdateIcrTouchConnectionDataFromJSONTyped(json, false);
}

export function UpdateIcrTouchConnectionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateIcrTouchConnectionData {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'tak': json['tak'] == null ? undefined : json['tak'],
    };
}

  export function UpdateIcrTouchConnectionDataToJSON(json: any): UpdateIcrTouchConnectionData {
      return UpdateIcrTouchConnectionDataToJSONTyped(json, false);
  }

  export function UpdateIcrTouchConnectionDataToJSONTyped(value?: UpdateIcrTouchConnectionData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'tak': value['tak'],
    };
}

